/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import dayjs from "dayjs";
import { updateUsers } from "../../../Redux/Slices/users.slice";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import { getTripsForDriverV3 } from "../../../Redux/APIs/tripsAPI";
import { updateQrCode } from "../../../Redux/Slices/qrcode.slice";
import { QR_CODE_TYPE } from "../../QRCode/data";
import {
  getDriversV3,
  getDriverUpcomingTrips,
  reinviteDriverV3,
  suspendOrResumeDriverV3,
} from "../../../Redux/APIs/usersAPI";
import useThreeDotsForDrivers from "./Driver/useThreeDotsForDrivers";
import useThreeDotsForFarmers from "./Partner/useThreeDotsForFarmers";
import { ITEM_STATUS } from "../../Login/constants";

const ListDropdown = ({ detail, type = "driver" }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { driverThreeDotsPopoverId, farmerThreeDotsPopoverId } = useSelector(
    (state) => state.users,
  );

  const { userDetails } = useSelector((state) => state.loggedInUser);

  const [open, setOpen] = useState(false);

  // fetch options based on type
  const options =
    type === "driver"
      ? useThreeDotsForDrivers().filter((item) => item.hasPermission)
      : useThreeDotsForFarmers().filter((item) => item.hasPermission);

  const driverInvitationExpired =
    dayjs().diff(dayjs(detail.signupCreatedAt), "hour") >= 24;

  const getFilteredOptions = () => {
    if (type === "driver") {
      let localOptions = [];

      // if the driver is suspended, option should show resume, else show suspend
      if (detail.isSuspended) {
        const filteredOptions = options.filter((item) => item.id !== 4);
        localOptions = [...filteredOptions];
      } else if (detail.isActive === 1) {
        const filteredOptions = options.filter(
          (item) => item.id !== 5 && item.id !== 8,
        );
        localOptions = [...filteredOptions];
      } else {
        const filteredOptions = options.filter(
          (item) =>
            item.id !== 5 &&
            item.id !== 7 &&
            ((detail.email !== null && driverInvitationExpired) ||
              item.id !== 8),
        );
        localOptions = [...filteredOptions];
      }
      return localOptions;
    }

    // options for partners
    let partnerOptions = [...options];

    if (+detail.isApproved !== 0) {
      partnerOptions = partnerOptions.filter((item) => item.id !== 4);
    }

    if (+detail.isActive === ITEM_STATUS.RETIRED) {
      partnerOptions = partnerOptions.filter(
        (item) =>
          item.id !== 7 && item.id !== 1 && item.id !== 3 && item.id !== 4,
      );
    } else {
      partnerOptions = partnerOptions.filter((item) => item.id !== 8);
    }

    return partnerOptions;
  };

  const onOptionClick = async (optionId) => {
    switch (optionId) {
      case 1:
        if (type === "driver") {
          setOpen(false);

          await dispatch(getTripsForDriverV3({ driverId: detail.id }));

          dispatch(
            updateUsers({
              key: "tripDetailsDrawer",
              value: {
                visible: true,
                driverName: `${detail.firstName} ${detail.lastName}`,
              },
            }),
          );
        } else {
          dispatch(
            updateUsers({
              key: "currentFarmer",
              value: detail,
            }),
          );
          navigate(`/edit-partner/${detail.id}`);
        }
        break;

      case 2:
        if (type === "driver") {
          dispatch(
            updateUsers({
              key: "currentDriver",
              value: detail,
            }),
          );
          navigate(`/edit-driver/${detail.id}`);
        } else {
          setOpen(false);

          dispatch(
            updateQrCode({
              key: "viewModal",
              value: {
                visible: true,
                data: {
                  assetId: `${detail.firstName} ${detail.lastName}`,
                  assetType: QR_CODE_TYPE.FARMER,
                  metaData: {
                    farmerid: detail.id,
                    contactno: detail.contactNo,
                    // collectionpointid: detail.locationId,
                    // collectionpointname: detail.locationName,
                  },
                },
              },
            }),
          );
        }
        break;

      case 3:
        if (type === "driver") {
          dispatch(
            updateUsers({
              key: "currentDriver",
              value: detail,
            }),
          );

          setOpen(false);

          await dispatch(getDriverUpcomingTrips({ driverId: detail.id }));

          dispatch(
            updateUsers({
              key: "deleteDriverModal",
              value: {
                visible: true,
                id: detail.id,
                name: `${detail.firstName} ${detail.lastName}`,
              },
            }),
          );
        } else {
          setOpen(false);

          dispatch(
            updateUsers({
              key: "deleteFarmerModal",
              value: {
                visible: true,
                id: detail.id,
                name: `${detail.firstName} ${detail.lastName}`,
              },
            }),
          );
        }
        break;
      case 4:
        if (type === "driver") {
          await dispatch(
            suspendOrResumeDriverV3({ driverId: detail.id, suspend: 1 }),
          );

          await dispatch(getDriversV3());
          dispatch(
            updateUsers({
              key: "showToastMessage",
              value: {
                visible: true,
                data: {
                  title: "1 Driver Suspended",
                  description: `${detail.firstName} ${detail.lastName} was suspended successfully.`,
                },
              },
            }),
          );
        } else {
          dispatch(
            updateUsers({
              key: "approveFarmerDrawer",
              value: {
                visible: true,
                data: detail,
              },
            }),
          );
        }

        setTimeout(() => {
          setOpen(false);
        }, 200);
        break;

      case 5:
        setOpen(false);
        await dispatch(
          suspendOrResumeDriverV3({ driverId: detail.id, suspend: 0 }),
        );

        await dispatch(getDriversV3());
        dispatch(
          updateUsers({
            key: "showToastMessage",
            value: {
              visible: true,
              data: {
                title: "1 Driver Resumed",
                description: `${detail.firstName} ${detail.lastName} was resumed successfully.`,
              },
            },
          }),
        );

        break;

      case 6:
        if (type === "driver") {
          dispatch(
            updateUsers({
              key: "driverDetailDrawer",
              value: {
                visible: true,
                data: detail,
              },
            }),
          );
        } else {
          dispatch(
            updateUsers({
              key: "partnerDetailDrawer",
              value: {
                visible: true,
                data: detail,
              },
            }),
          );
        }

        setTimeout(() => {
          setOpen(false);
        }, 200);
        break;

      case 7:
        if (type === "driver") {
          setOpen(false);

          dispatch(
            updateTrips({
              key: "driverRatingModal",
              value: {
                visible: true,
                driverId: detail.id,
                driverName: `${detail.firstName} ${detail.lastName}`,
              },
            }),
          );
        } else {
          setOpen(false);
          dispatch(
            updateUsers({
              key: "retireFarmerModal",
              value: {
                visible: true,
                id: detail.id,
                name: `${detail.firstName} ${detail.lastName}`,
              },
            }),
          );
        }
        break;
      case 8:
        if (type === "driver") {
          setOpen(false);
          await dispatch(reinviteDriverV3({ email: detail.email }));
          await dispatch(getDriversV3());

          dispatch(
            updateUsers({
              key: "showToastMessage",
              value: {
                visible: true,
                data: {
                  title: "Invitation sent!",
                  description: `Invitation sent to ${detail.firstName} ${detail.lastName} successfully.`,
                },
              },
            }),
          );
        } else {
          setOpen(false);
          dispatch(
            updateUsers({
              key: "unretireFarmerModal",
              value: {
                visible: true,
                id: detail.id,
                name: `${detail.firstName} ${detail.lastName}`,
              },
            }),
          );
        }
        break;

      default:
        break;
    }
  };

  // handle on open change of popover
  const handleOpenChange = (state) => {
    setOpen(state);

    dispatch(
      updateUsers({
        key:
          type === "driver"
            ? "driverThreeDotsPopoverId"
            : "farmerThreeDotsPopoverId",
        value: detail.id,
      }),
    );
  };

  // get popover state
  const getOpenState = () => {
    if (type === "driver") {
      return open && detail.id === driverThreeDotsPopoverId;
    }

    return open && detail.id === farmerThreeDotsPopoverId;
  };

  // if three dots has no items (depending on the permission) then return empty fragments
  if (!getFilteredOptions().length) {
    return <></>;
  }

  // do not show the three dots options if the user does not have access in that hub
  if (detail.hubId && !userDetails.hubs.includes(+detail.hubId)) {
    return <div />;
  }

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={getOpenState()}
      arrow={false}
      onOpenChange={(state) => handleOpenChange(state)}
      content={
        <div
          className="rounded-md bg-background-white"
          style={{
            width: type === "driver" ? "156px" : "186px",
            boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.10)",
            paddingTop: options.length && "4px",
            paddingBottom: options.length && "4px",
          }}
        >
          {getFilteredOptions().map((option) => (
            <button
              type="button"
              className={`w-full flex items-center gap-x-3 px-3 py-2 group
              ${
                option.id === 3
                  ? "hover:bg-light-alert-red-hover"
                  : "hover:bg-background"
              }
              `}
              key={option.id}
              onClick={() => onOptionClick(option.id)}
            >
              {option.icon}
              <p
                className={`font-aileron text-xs font-semibold capitalize ${
                  option.id === 3
                    ? "text-alert-red group-hover:text-alert-red-hover"
                    : "text-dark-gray group-hover:text-black"
                }`}
              >
                {option.value}
              </p>
            </button>
          ))}
        </div>
      }
    >
      <div className="cursor-pointer">
        <img src="/assets/icons/trips/more.svg" alt="dropdown" />
      </div>
    </Popover>
  );
};

export default ListDropdown;
